<template>
	<div class="information">
		<el-tabs v-model="activeName" type="card">
			<el-tab-pane label="自建库存" name="first">
				<el-row>
					<el-form :model="ruleForm" ref="ruleForm" label-width="100px"
						style="overflow: hidden;margin-top:30px" class="demo-ruleForm">
						<el-col :span="5">
							<el-form-item label="开始日期" prop="starttime">
								<el-date-picker v-model="ruleForm.starttime" @change="startTime" align="right"
									type="date" placeholder="选择开始日期" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="5">
							<el-form-item label="结束日期" prop="Jieshutime">
								<el-date-picker v-model="ruleForm.Jieshutime" @change="endTime" align="right"
									type="date" placeholder="选择结束日期" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="7">
							<el-form-item prop="searchInput" style="margin-left: 0px;">
								<el-input v-model="ruleForm.searchInput" placeholder="库存编号、商品全称、商品简称"
									style="width: 65%;"></el-input>
								<el-button type="primary" @click="search2" style="margin-left:20px;">搜索</el-button>
								<el-button type="primary" @click="resetFprm">重置</el-button>
							</el-form-item>
						</el-col>
					</el-form>
				</el-row>
				<el-row>
					<el-button type="primary" @click="Addinventory">新增产品库存</el-button>
				</el-row>

				<el-divider></el-divider>
				<el-table width="100%" :data="tableData" border v-loading="loading">
					<el-table-column width="200" sortable sort-by="inventoryNumber" label="库存编号" align="center">
						<template slot-scope="scope">
							<p>库存号:{{ scope.row.inventoryNumber }}</p>
							<!-- <p>批次号:{{scope.row.inventoryBatchNo}}</p> -->
						</template>
					</el-table-column>
					<el-table-column label="商品图片" align="center" width="78">
						<template slot-scope="scope">
							<el-popover trigger="hover" placement="right">
								<img :src="scope.row.images" class="prduct_img" alt />
								<div class="scope_img" slot="reference">
									<img :src="scope.row.images" alt />
								</div>
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column prop="productFullName" label="商品全称" align="center"></el-table-column>
					<el-table-column prop="productSimpleName" label="商品简称" align="center"></el-table-column>
					<el-table-column prop="productDescription" label="商品描述" align="center"></el-table-column>
					<!-- <el-table-column
						prop="purchasePrice"
						width="80"
						label="采购单价"
						align="center"
					></el-table-column> -->
					<el-table-column prop="inventorySku" label="规格尺寸" align="center"></el-table-column>
					<el-table-column prop="purchaseQuantity" label="采购数量" align="center"></el-table-column>
					<el-table-column prop="predictCount" label="申请库存" align="center"></el-table-column>
					<el-table-column prop="actualCount" label="实际库存" align="center"></el-table-column>
					<!-- <el-table-column
						width="100"
						label="平均计费量"
						align="center"
					>
						<template slot-scope="scope">
							{{ scope.row.averageWeight | numFilter }}
						</template>
					</el-table-column> -->
					<!-- <el-table-column
						prop="storageCharges"
						width="120"
						label="仓储费用/每天"
						align="center"
					></el-table-column> -->
					<!-- <el-table-column
						prop="putStorageTime"
						width="160"
						label="入库时间"
						align="center"
					></el-table-column> -->
					<el-table-column prop="updateTime" sortable width="200" label="更新时间"
						align="center"></el-table-column>
					<el-table-column label="操作" align="center" width="280">
						<template slot-scope="scope">
							<span v-if="scope.row.status == 2" style="color:red;">销毁中</span>
							<el-button v-if="scope.row.status !== 2" type="primary"
								@click="Edit(scope.row)">库存编辑</el-button>
							<el-button type="primary" @click="buildSku(scope.row)">绑定sku</el-button>
							<el-button :disabled="scope.row.actualCount !== 0 &&
								scope.row.actualCount !== null
								" type="danger" @click="del(scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="page">
					<el-pagination style="margin-right:200px;" layout="total, sizes, prev, pager, next, jumper"
						:page-sizes="[20, 50, 100, 200]" :page-size="pagesize" :current-page="currentPage"
						:total="total" @size-change="handleSizeChange"
						@current-change="handleCurrentChange"></el-pagination>
				</div>
				<Addinventory ref="Addinventory" @Addinventory="search" />
				<buildbyoneself ref="buildbyoneself" @Editinventory="search" />
			</el-tab-pane>
			<!-- --------------------------库存批次 ----------------------- -->
			<el-tab-pane label="库存批次" name="second">
				<el-form :model="Batch_Form" ref="Batch_Form" label-width="100px"
					style="overflow: hidden;margin-top:30px" class="demo-ruleForm">
					<el-col :span="5">
						<el-form-item label="开始日期" prop="starttime">
							<el-date-picker v-model="Batch_Form.startTimeString" align="right" type="date"
								placeholder="选择开始日期" format="yyyy-MM-dd HH:mm:ss"
								value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label="结束日期" prop="Jieshutime">
							<el-date-picker v-model="Batch_Form.endTimeString" align="right" type="date"
								placeholder="选择结束日期" format="yyyy-MM-dd HH:mm:ss"
								value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="7">
						<el-form-item prop="searchInput" style="margin-left: 0px;">
							<el-input v-model="Batch_Form.searchString" placeholder="库存编号、商品全称、商品简称"
								style="width: 65%;"></el-input>
							<el-button type="primary" @click="BatchSearch" style="margin-left:20px;">搜索</el-button>
							<el-button type="primary" @click="ResetBatch">重置</el-button>
						</el-form-item>
					</el-col>
				</el-form>
				<el-table :data="BatchData" border style="width: 100%">
					<el-table-column width="240" label="库存编号" align="center">
						<template slot-scope="scope">
							<p>
								批次号：
								<span v-if="
									scope.row.confirmStatus == 0 ||
									scope.row.confirmStatus == null
								">--</span>
								<span v-if="
									scope.row.confirmStatus != 0 &&
									scope.row.confirmStatus != null
								">{{ scope.row.inventoryBatchNo }}</span>
							</p>
							<p>
								库存号：
								<span v-if="
									scope.row.confirmStatus == 0 ||
									scope.row.confirmStatus == null
								">--</span>
								<span v-if="
									scope.row.confirmStatus != 0 &&
									scope.row.confirmStatus != null
								">{{ scope.row.inventoryNumber }}</span>
							</p>
						</template>
					</el-table-column>
					<el-table-column label="商品图片" width="78" align="center">
						<template slot-scope="scope">
							<el-popover trigger="hover" placement="right">
								<img :src="scope.row.images" class="prduct_img" alt />
								<div class="scope_img" slot="reference">
									<img :src="scope.row.images" alt />
								</div>
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column prop="productFullName" width="150" label="商品全称" align="center"></el-table-column>
					<el-table-column prop="productSimpleName" width="100" label="商品简称" align="center"></el-table-column>
					<el-table-column prop="inventorySku" width="100" label="型号尺码" align="center"></el-table-column>
					<el-table-column prop="productDescription" width="180" label="商品描述"
						align="center"></el-table-column>
					<el-table-column width="200" label="国内运单" align="center">
						<template slot-scope="scope">
							<el-popover placement="top" width="800" trigger="click" :open-delay="1000"
								@show="popoverShow(scope.row)">
								<template>
									<div style="width: 100%;text-align: center;" v-if="popoverStatus">
										{{ popoverText }}
									</div>
									<div style="width: 100%;" v-else>
										<div v-if="popoverInfo.number" style="margin-bottom: 10px;">
											<span>运单号：{{
												popoverInfo.number
											}}</span>
											<span style="margin-left: 10px;">{{
												popoverInfo.track_info.latest_status.status
											}}</span>
										</div>
										<div v-if="popoverInfo.track_info" style="margin-bottom: 10px;">
											<span>时效信息: </span>
											<span style="margin-left: 10px;">订单:{{
												popoverInfo.track_info.time_metrics.days_after_order
											}}天</span>
											<span style="margin-left: 10px;">运输:{{
												popoverInfo.track_info.time_metrics.days_of_transit
											}}天</span>
											<span style="margin-left: 10px;">妥投:{{
												popoverInfo.track_info.time_metrics.days_of_transit_done
											}}天</span>
											<span style="margin-left: 10px;">无更新:{{
												popoverInfo.track_info.time_metrics.days_after_last_update
											}}天</span>
										</div>
										<div v-if="popoverInfo.track_info" style="height: 200px;overflow: auto;">
											<div v-for="(item, index) in popoverInfo.track_info.tracking.providers[0].events"
												:key="index" style="margin-bottom: 5px;">
												<div>{{ item.description }}</div>
												<div>{{ timeConversion(item.time_iso) }}</div>
											</div>
										</div>
									</div>
								</template>
								<template slot="reference">
									<el-row type="flex" justify="center" align="middle">
										<div style="cursor: pointer;">
											<span>
												{{ scope.row.internalConveyNumber }}
											</span>
										</div>
									</el-row>
								</template>
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column prop="purchasePrice" width="80" label="采购单价" align="center"></el-table-column>
					<el-table-column prop="predictCount" width="80" label="采购库存" align="center"></el-table-column>
					<el-table-column prop="actualCount" width="80" label="实际库存" align="center"></el-table-column>
					<el-table-column width="100" label="平均计费量" align="center">
						<template slot-scope="scope">
							{{ scope.row.averageWeight | numFilter }}
						</template>
					</el-table-column>
					<el-table-column prop="storageCharges" width="110" label="仓储费用/每天" align="center"></el-table-column>
					<el-table-column prop="putStorageTime" width="160" label="入库时间" align="center"></el-table-column>
					<el-table-column prop="updateTime" width="160" label="更新时间" align="center"></el-table-column>
					<el-table-column label="操作" fixed="right" align="center" width="200">
						<template slot-scope="scope">
							<!-- <span
								v-if="scope.row.status == 2"
								style="color:red;"
								>销毁中</span
							> -->

							<el-button :disabled="str.type != 3" type="primary"
								@click="EditUnivalence(scope.row)">库存编辑</el-button>
							<!-- <el-button
								:disabled="
									scope.row.actualCount !== 0 &&
										scope.row.actualCount !== null
								"
								type="danger"
								@click="del(scope.row)"
								>删除</el-button
							> -->
						</template>
					</el-table-column>
				</el-table>
				<div class="page">
					<el-pagination style="margin-right:200px;" layout="total, sizes, prev, pager, next, jumper"
						:page-sizes="[20, 50, 100, 200]" :page-size="pagesize" :current-page="Batch_Form.page"
						:total="InitiaTotal" @size-change="BatcSizeChange"
						@current-change="BatcCurrentChange"></el-pagination>
				</div>
				<el-dialog width="30%" title="批次价格编辑" :visible.sync="innerThirdVisible" append-to-body
					:before-close="Close_Edit_">
					<el-form label-width="100px" label-position="left">
						<el-form-item label="修改价格">
							<el-input placeholder="请输入" v-model.number="Edit_Price.purchasePrice"></el-input>
						</el-form-item>
					</el-form>
					<span slot="footer" class="dialog-footer">
						<el-button type="primary" @click="accomplish">完 成</el-button>
					</span>
				</el-dialog>
			</el-tab-pane>
			<!-- --------------------------云仓库存 ----------------------- -->
			<el-tab-pane label="云仓库存" name="three">
				<el-form :model="cloudWarehouse" ref="cloudWarehouse" label-width="100px"
					style="overflow: hidden;margin-top:30px" class="demo-ruleForm">
					<el-col :span="5">
						<el-form-item label="开始日期" prop="starttime">
							<el-date-picker v-model="cloudWarehouse.startTimeString" align="right" type="date"
								placeholder="选择开始日期" format="yyyy-MM-dd HH:mm:ss"
								value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label="结束日期" prop="Jieshutime">
							<el-date-picker v-model="cloudWarehouse.endTimeString" align="right" type="date"
								placeholder="选择结束日期" format="yyyy-MM-dd HH:mm:ss"
								value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="7">
						<el-form-item prop="searchInput" style="margin-left: 0px;">
							<el-input v-model="cloudWarehouse.searchString" placeholder="云仓Sku、商品Sku"
								style="width: 65%;"></el-input>
							<el-button type="primary" @click="cloudWarehouseList"
								style="margin-left:20px;">搜索</el-button>
							<el-button type="primary" @click="ResetCloudWarehouse">重置</el-button>
						</el-form-item>
					</el-col>
				</el-form>
				<el-row type="flex" align="middle">
					<upload-excel-component :on-success="handleUploadExcelSuccess" />
					<el-button style="margin-left: 10px;" type="primary" @click="downloadTemplate">下载模板</el-button>
					<el-button style="margin-left: 10px;" type="primary" @click="updateInventory">更新库存</el-button>
					<el-button style="margin-left: 10px;" type="primary" @click="updatePrice">更新价格</el-button>
					<el-button style="margin-left: 10px;" type="danger" @click="cloudDel">批量删除</el-button>
				</el-row>
				<el-table :data="cloudWarehouseData" border style="width: 100%;margin-top: 20px;"
					@selection-change="on_batch_select">
					<el-table-column width="54" type="selection" align="center"></el-table-column>
					<el-table-column prop="gigaSku" width="400" label="云仓Sku" align="center"></el-table-column>
					<el-table-column prop="sku" label="商品SKU" width="400" align="center"></el-table-column>
					<el-table-column prop="quantity" width="125" label="云仓库存" align="center"></el-table-column>
					<el-table-column prop="inventoryStatus" label="库存状态" align="center" width="100">
						<template slot-scope="{ row }">
							<span :style="getStockStatusStyle(row.inventoryStatus)">
								{{ getStockStatusText(row.inventoryStatus) }}
							</span>
						</template>
					</el-table-column>

					<el-table-column prop="price" width="125" label="单价" align="center">
						<template slot-scope="{ row }">
							<span>
								{{ row.price }} ({{ row.currency }})
							</span>
						</template>
					</el-table-column>
					<el-table-column prop="quantity" width="250" label="运费" align="center">
						<template slot-scope="{ row }">
							<span>
								{{ row.shippingFeeMax }} - {{ row.shippingFeeMin }} ({{ row.currency }})
							</span>
						</template>
					</el-table-column>
					<el-table-column prop="updateTime" width="200" label="更新时间" align="center"></el-table-column>
				</el-table>
				<div class="page">
					<el-pagination style="margin-right:200px;" layout="total, sizes, prev, pager, next, jumper"
						:page-sizes="[20, 50, 100, 200]" :page-size="cloudWarehouse.size"
						:current-page="cloudWarehouse.page" :total="cloudWarehouseTotal"
						@size-change="cloudWarehouseSizeChange"
						@current-change="cloudWarehouseCurrentChange"></el-pagination>
				</div>
			</el-tab-pane>
		</el-tabs>
		<el-dialog
			title="绑定sku"
			:visible.sync="dialogVisible"
			top="4vh"
			width="90%">
			<div class="info-box">
				<!-- 库存信息 -->
				<div class="left">
					<img :src="inventoryInfo.images" class="prduct_img" alt />
				</div>
				<div class="right">
					<div class="row">
						<div class="item">
							库存号：{{ inventoryInfo.inventoryNumber }}
						</div>
					</div>
					<div class="row">
						<div>
							商品全称：{{ inventoryInfo.productFullName }}
						</div>
					</div>
					<div class="row">
						<div class="item">
							商品简称：{{ inventoryInfo.productSimpleName }}
						</div>
					</div>
					<div class="row">
						<div class="item">
							商品描述：{{ inventoryInfo.productDescription }}
						</div>
					</div>
					<div class="row">
						<div class="item">
							规格尺寸：{{ inventoryInfo.inventorySku }}
						</div>
					</div>
				</div>
			</div>
			<div class="search-row">
				<div class="search-item">
					<div class="text">
						店铺：
					</div>
					<el-select v-model="searchShop" placeholder="选择店铺" clearable filterable>
						<el-option
							v-for="item in shopOptions"
							:key="item.value"
							:label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</div>
				<div class="search-item">
					<div class="text">
						运营填的sku：
					</div>
					<el-input v-model="searchSku" placeholder="请输入" clearable></el-input>
				</div>
				<div class="search-item">
					<div class="text">
						采购链接中的sku：
					</div>
					<el-input v-model="searchDetailSku" placeholder="请输入" clearable></el-input>
				</div>
				<el-button type="primary" @click="searchSkuList">查询</el-button>
				<el-button type="primary" @click="initSkuList">重置</el-button>
				<el-pagination
					@size-change="handleSizeChange11"
					@current-change="handleCurrentChange11"
					:current-page="currentPage11"
					:page-sizes="[50, 100, 300, 500]"
					:page-size="pageSize11"
					layout="total, sizes, prev, pager, next, jumper"
					:total="skuTotal">
				</el-pagination>
			</div>
			<div class="sku-list">
				<div class="item" v-for="(item, index) in skuList" :key="index" :class="activeSku.includes(item.sku + '------' + item.shopId + '------' + item.purchaseDetailSku) ? 'active' : ''">
					<img :src="item.imageUrl" class="prduct_img" alt @click="changeSkuState(item)" />
					<div class="text">{{ item.sku }}</div>
					<div class="text">{{ item.shopName }}</div>
					<div class="text">{{ item.purchaseDetailSku }}</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="saveBuildSku">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
// 库存编辑
import buildbyoneself from './buildbyoneself/buildbyoneself'
// 新增产品库存
import Addinventory from './buildbyoneself/Addinventory'
import UploadExcelComponent from '@/components/UploadExcel/index.vue'
import { ajaxGet, ajaxPost, Baseurl } from '../../api/api/api'
export default {
	name: 'information',
	components: {
		buildbyoneself,
		Addinventory,
		UploadExcelComponent
	},
	data() {
		return {
			innerThirdVisible: false,
			univalence: '',
			activeName: 'first',
			currentPage: 1,
			pagesize: 5,
			size: 20,
			total: 0,
			InitiaTotal: 0,
			cloudWarehouseTotal: 0,
			UserInfo: {},
			Edit_Price: { id: null, purchasePrice: 0 },
			ruleForm: {
				starttime: '', //开始时间
				Jieshutime: '', //结束时间
				searchInput: '', //全字段搜索
			},
			Batch_Form: {
				startTimeString: '', // 开始时间
				endTimeString: '', // 结束时间
				searchString: '', // 搜索字段
				companyId: null,
				page: 1,
				size: 20,
			},
			cloudWarehouse: {
				startTimeString: '', // 开始时间
				endTimeString: '', // 结束时间
				searchString: '', // 搜索字段
				page: 1,
				size: 20,
			},
			tableData: [],
			BatchData: [
				// {
				// 	date: '2016-05-02',
				// 	name: '王小虎',
				// 	province: '上海',
				// 	city: '普陀区',
				// 	address: '上海市普陀区金沙江路 1518 弄',
				// 	zip: 200333,
				// },
			],
			cloudWarehouseData: [],
			loading: false,
			popoverStatus: true,
			popoverText: '查询中...',
			popoverInfo: null,
			cloudDelList: null,
			dialogVisible: false,
			inventoryInfo:{},
			shopOptions: [],
			searchShop: '',
			searchSku: '',
			searchDetailSku: '',
			pageSize11: 50,
			currentPage11: 1,
			skuTotal: 0,
			skuList:[],
			activeSku: [],
		}
	},
	filters: {
		numFilter(value) {
			// 截取当前数据到小数点后两位
			let realVal = parseFloat(value).toFixed(2)
			return realVal
		},
	},
	mounted() { },
	created() {
		this.str = JSON.parse(localStorage.getItem('role'))
		this.search()
		this.BatchMark()
		this.cloudWarehouseList()
		this.getSkuShopList();
	},
	methods: {
		saveBuildSku(){
			const result = [];
			for(let i = 0; i < this.activeSku.length; i++){
				const arr = this.activeSku[i].split('------');
				result.push({
					purchaseSkuSku: arr[0],
					purchaseSkuShopId: +arr[1],
					purchaseSkuPurchaseDetailSku: arr[2]
				})
			}
			const params = {
				inventoryNumber: this.inventoryInfo.inventoryNumber,
				data: result
			}
			ajaxPost(
				Baseurl + 'inventoryPurchaseSkuController/save',
				params
			).then((res) => {
				if (res.data.code == 200) {
					this.$message.success("绑定成功");
				}else{
					this.$message.error(res.data.code)
				}
			})
		},
		changeSkuState(item){
			const text = item.sku + '------' + item.shopId + '------' + item.purchaseDetailSku;
			const index = this.activeSku.indexOf(text);
			if(index === -1){
				this.activeSku.push(text);
			}else{
				this.activeSku.splice(index, 1);
			}
		},
		getSkuShopList(){
			ajaxGet(
				Baseurl + 'purchaseSkuController/getShopList',
			).then((res) => {
				if (res.data.code == 200) {
					this.shopOptions = res.data.data;
				}
			})
		},
		buildSku(row){
			this.activeSku = [];
			this.getSkuList();
			this.inventoryInfo = row;
			this.getMatchedSku();
			this.dialogVisible = true
		},
		getMatchedSku(){
			const params = {
				inventoryNumber: this.inventoryInfo.inventoryNumber,
			};
			ajaxPost(
				Baseurl + 'inventoryPurchaseSkuController/list',
				params
			).then((res) => {
				if (res.data.code == 200) {
					const result = res.data.data;
					for(let i = 0; i < result.length; i++){
						this.activeSku.push(result[i].purchaseSkuSku + '------' + result[i].purchaseSkuShopId + '------' + result[i].purchaseSkuPurchaseDetailSku);
					}
				}
			})
		},
		searchSkuList(){
			this.pageSize11 = 50;
			this.currentPage11 = 1;
			this.getSkuList();
		},
		initSkuList(){
			this.searchShop = '';
			this.searchSku = '';
			this.searchDetailSku = '';
			this.pageSize11 = 50;
			this.currentPage11 = 1;
			this.getSkuList();
		},
		getSkuList(){
			this.skuList = [];
			const params = {
				shopId: this.searchShop ? this.searchShop + '' : '',
				sku: this.searchSku,
				purchaseDetailSku: this.searchDetailSku,
				pageSize: this.pageSize11,
				currentPage: this.currentPage11,
			};
			ajaxPost(
				Baseurl + 'purchaseSkuController/getList',
				params
			).then((res) => {
				if (res.data.code == 200) {
					const result = res.data.data;
					if(result.total == 0){
						this.$message.warning("没有查到数据");
					}
					this.skuTotal = result.total;
					this.skuList = result.list;
				}
			})
		},
		handleSizeChange11(e){
			this.pageSize11 = e;
			this.currentPage11 = 1;
			this.getSkuList();
		},
		handleCurrentChange11(e){
			this.currentPage11 = e;
			this.getSkuList();
		},
		getStockStatusText(quantity) {
			const statusMap = {
				0: "清零",
				1: "正常",
				2: "补仓"
			};
			return statusMap[quantity] || "未知";
		},
		getStockStatusStyle(quantity) {
			const colorMap = {
				0: "color: red;",   // 清零 - 红色
				1: "color: black;", // 正常 - 默认黑色
				2: "color: green;"  // 补仓 - 绿色
			};
			return colorMap[quantity] || "color: gray;";
		},
		on_batch_select(val) {
			var newarr = [];
			this.piece = val.length;
			for (var i = 0; i < val.length; i++) {
				newarr.push(val[i].id);
			}
			this.cloudDelList = newarr
		},
		cloudDel() {
			if (this.cloudDelList != null) {
				ajaxPost(
					Baseurl + 'gigaSkuQuantity/deleteQuantity',
					{ ids: this.cloudDelList }
				).then((res) => {
					if (res.data.code == 200) {
						this.$message.success('删除成功!')
						this.cloudWarehouseList()
					}
				})
			} else {
				this.$message.error('请勾选删除数据!')
			}
		},
		downloadTemplate() {
			const a = document.createElement('a')
			a.href = 'https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/giga%E4%BA%91%E4%BB%93%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
			a.download = 'https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/giga%E4%BA%91%E4%BB%93%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
			a.click()
			this.$message.success('正在下载...')
		},
		updateInventory() {
			let Role = JSON.parse(localStorage.getItem('role'))
			let paramsData = {
				rid: Role.rid
			}
			ajaxPost(
				Baseurl + 'gigaSkuQuantity/syncQuantity',
				paramsData
			).then((res) => {
				if (res.data.code == 200) {
					this.$message.success('更新成功!共' + res.data.data + '条')
					this.cloudWarehouseList()
				}
			})
		},
		updatePrice() {
			let Role = JSON.parse(localStorage.getItem('role'))
			let paramsData = {
				rid: Role.rid
			}
			ajaxPost(
				Baseurl + 'gigaSkuQuantity/syncPrice',
				paramsData
			).then((res) => {
				if (res.data.code == 200) {
					this.$message.success('更新成功!共' + res.data.data + '条')
					this.cloudWarehouseList()
				}
			})
		},
		handleUploadExcelSuccess({ results, header, fileName }) {
			let returnList = results.map(item => ({
				gigaSku: item.云仓sku,
				sku: item.商品sku
			}))
			console.log(returnList);
			ajaxPost(
				Baseurl + 'gigaSkuQuantity/importGigaSkuQuantity/' + JSON.parse(localStorage.getItem('role')).rid,
				returnList
			).then((res) => {
				if (res.data.code == 200) {
					this.$message.success('导入成功!共' + res.data.data.successCount + '条')
					this.cloudWarehouseList()
				}
			})
		},
		// 时间转换
		timeConversion(item) {
			const date = new Date(item);
			const year = date.getFullYear();
			const month = (date.getMonth() + 1).toString().padStart(2, '0');
			const day = date.getDate().toString().padStart(2, '0');
			const hour = date.getHours().toString().padStart(2, '0');
			const minute = date.getMinutes().toString().padStart(2, '0');
			const seconds = date.getSeconds().toString().padStart(2, '0');
			const formattedTime = `${year}/${month}/${day} ${hour}:${minute}:${seconds}`
			return formattedTime
		},
		async popoverShow(item) {
			this.popoverText = '查询中...'
			this.popoverStatus = true
			const queryTrackSwitch = this.str.company.queryTrackSwitch
			try {
				if (queryTrackSwitch === 1) {
					// 快递100物流轨迹查询
					// const data = await this.queryDomesticOrderMove(item)
					// if (data.status === '200') {
					//     this.popoverStatus = false
					//     this.popoverInfo = data
					// } else {
					//     this.popoverText = data.message || '查询失败'
					// }
					const data = await this.query17Trackinfo(item)  // 17track物流轨迹查询
					if (data.code === 0 && data.data.accepted && data.data.accepted.length > 0) {
						this.popoverStatus = false
						this.popoverInfo = data.data.accepted[0]
					} else if (data.code === 0 && data.data.rejected && data.data.rejected.length > 0) {
						this.popoverText = data.data.rejected[0].error.message
					} else {
						this.popoverText = data.message || '查询失败'
					}
				} else {
					this.popoverText = '贵司尚未开启物流轨迹查询!'
				}

			} catch (error) {
				this.popoverText = error || '查询失败'
			}
		},
		query17Trackinfo(item) {
			const API = Baseurl + 'track17Controller/gettrackinfo'
			const paramsDate = [{
				number: item.internalConveyNumber,
				carrier: !isNaN(item.companyCode) ? item.companyCode : null,
			}]
			return new Promise((resolve, reject) => {
				ajaxPost(API, paramsDate).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						resolve(data)
					} else {
						reject(data)
					}
				})
			})
		},
		Close_Edit_(done) {
			this.$confirm('您的操作不会被保存，确认关闭吗？')
				.then((_) => {
					done()
					this.Edit_Price.id = null
					this.Edit_Price.purchasePrice = 0
				})
				.catch((_) => {
					//   this.Base_form();
				})
		},
		accomplish() {
			let API = Baseurl + 'inventoryController/updateInventoryBatchPrice'
			// console.log(this.Edit_Price.purchasePrice)
			if (!this.Edit_Price.purchasePrice) {
				this.$message.info('修改价格不能为空！')
				return
			} else if (typeof this.Edit_Price.purchasePrice != 'number') {
				this.$message.info('请填写数字！')
				return
			}
			ajaxPost(API, this.Edit_Price).then((res) => {
				if (res.data.code == 200) {
					this.$message.success(res.data.data)
					this.innerThirdVisible = false
					this.BatchMark()
				} else {
					this.$message.error(res.data.data)
				}
			})
		},
		EditUnivalence(item) {
			this.Edit_Price.id = item.id
			this.Edit_Price.purchasePrice = item.purchasePrice
			this.innerThirdVisible = true
		},
		handleClick() { },
		Edit(e) {
			this.$refs.buildbyoneself.init(e)
		},
		startTime(val) {
			var d = new Date(val)
			var datetime =
				d.getFullYear() +
				'-' +
				(d.getMonth() + 1) +
				'-' +
				d.getDate() +
				' 00:00:00'
			this.ruleForm.starttime = datetime
			//console.log(val);
		},
		// 选择结束时间
		endTime(val) {
			var d = new Date(val)
			var datetime =
				d.getFullYear() +
				'-' +
				(d.getMonth() + 1) +
				'-' +
				d.getDate() +
				' 23:59:59'
			this.ruleForm.Jieshutime = datetime
			// console.log(val);
		},
		search2() {
			this.currentPage = 1
			this.search()
		},
		BatchSearch() {
			this.Batch_Form.page = 1
			this.BatchMark()
			// console.log(this.Batch_Form)
		},
		BatchMark() {
			// 批次列表
			let Role = JSON.parse(localStorage.getItem('role'))
			this.Batch_Form.companyId = Role.company_id
			// console.log(this.Batch_Form)
			ajaxPost(
				Baseurl + 'inventoryController/selectInventoryBatchList',
				this.Batch_Form
			).then((res) => {
				if (res.status == 200) {
					this.BatchData = res.data.data.list
					this.InitiaTotal = res.data.data.total
				}
			})
		},
		cloudWarehouseList() {
			let Role = JSON.parse(localStorage.getItem('role'))
			this.cloudWarehouse.rid = Role.rid
			ajaxPost(
				Baseurl + 'gigaSkuQuantity/pageInfo',
				this.cloudWarehouse
			).then((res) => {
				if (res.status == 200) {
					this.cloudWarehouseData = res.data.data.list
					this.cloudWarehouseTotal = res.data.data.total
				}
			})
		},
		search() {
			this.loading = true
			// 库存列表
			var obj = {
				page: this.currentPage,
				size: this.size,
				startTimeString: this.ruleForm.starttime,
				endTimeString: this.ruleForm.Jieshutime,
				searchString: this.ruleForm.searchInput,
				companyId: this.str.company_id,
			}
			ajaxPost(
				Baseurl + 'inventoryController/selectInventoryList',
				obj
			).then((res) => {
				if (res.data.code === 200) {
					// console.log(res)
					this.tableData = res.data.data.list
					this.total = res.data.data.total
				}
				this.loading = false
			})
		},
		del(val) {
			this.$confirm(
				'该操作会导致未入库的库存无法正常入库，无法对应，易导致货物丢失，请谨慎操作，是否继续删除？',
				'提示',
				{
					confirmButtonText: '是',
					cancelButtonText: '否',
					type: 'warning',
				}
			).then(() => {
				var obj = {
					id: val.id,
				}
				ajaxPost(
					Baseurl + 'inventoryController/updateInventoryStatusById',
					obj
				).then((res) => {
					if (res.data.code === 200) {
						this.search()
					} else {
						this.$message.error(res.data.data)
					}
				})
			})
		},
		resetFprm() {
			this.ruleForm.starttime = ''
			this.ruleForm.Jieshutime = ''
			this.ruleForm.searchInput = ''
			this.currentPage = 1
			this.search()
		},
		ResetBatch() {
			// Batch_Form: {
			//     startTimeString:"",// 开始时间
			//     endTimeString:"", // 结束时间
			//     searchString:"", // 搜索字段
			//     companyId:null,
			//     page:1,
			//     size:20
			// },
			this.Batch_Form.startTimeString = ''
			this.Batch_Form.endTimeString = ''
			this.Batch_Form.searchString = ''
			this.Batch_Form.page = 1
			this.Batch_Form.size = 20
			this.BatchMark()
		},
		ResetCloudWarehouse() {
			this.cloudWarehouse.startTimeString = ''
			this.cloudWarehouse.endTimeString = ''
			this.cloudWarehouse.searchString = ''
			this.cloudWarehouse.page = 1
			this.cloudWarehouse.size = 20
			this.cloudWarehouseList()
		},
		Addinventory() {
			this.$refs.Addinventory.init()
		},
		handleSizeChange(val) {
			this.size = val
			this.search()
		},
		handleCurrentChange(val) {
			this.currentPage = val
			this.search()
		},
		BatcSizeChange(size) {
			this.InitialSize = size
			this.BatchMark()
		},
		BatcCurrentChange(page) {
			this.Batch_Form.page = page
			this.BatchMark()
		},
		cloudWarehouseSizeChange(size) {
			this.cloudWarehouse.size = size
			this.cloudWarehouseList()
		},
		cloudWarehouseCurrentChange(page) {
			this.cloudWarehouse.page = page
			this.cloudWarehouseList()
		},
	},
}
</script>

<style lang="scss" scoped>
/deep/ {
	.layout .layout-section ::-webkit-scrollbar {
		width: 10px;
		height: 10px;
		background-color: #b71e1e;
	}

	.el-form-item__content {
		margin-left: 0px !important;
	}

	.el-divider--horizontal {
		margin: 15px 0;
	}
}

.information {
	width: 98%;
	overflow: hidden;
	margin-bottom: 50px;
}

.scope_img {
	width: 55px;
	height: 55px;

	img {
		width: 100%;
		height: 100%;
	}
}

.prduct_img {
	width: 300px;
	height: 300px;
}

.padding {
	padding: 5px 0;
}

.line-height {
	line-height: 35px;
}

.page {
	position: fixed;
	width: 100%;
	bottom: 0;
	background-color: white;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 50px;
	z-index: 99;
}
.info-box{
	display: flex;
	.left{
		width: 120px;
		height: 120px;
		img{
			width: 100%;
			height: 100%;
		}
	}
	.right{
		flex: 1;
		margin-left: 20px;
		.row{
			display: flex;
			// justify-content: space-evenly;
			margin: 5px 0;
		}
	}
}
.search-row{
	display: flex;
	align-items: center;
	margin: 10px 0;
	.search-item{
		display: flex;
		align-items: center;
		margin-right: 10px;
		.text{
			white-space: nowrap;
		}
	}
}
.sku-list{
	display: grid;
	grid-template-columns: repeat(7, 1fr); /* 每行4列，平均分 */
	gap: 10px; /* 元素间距，可选 */
	.item{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 10px;
		box-sizing: border-box;
		border: 1px solid #ccc;
		cursor: pointer;
		img{
			width: 200px;
			height: 200px;
		}
		&.active{
			border-color: red;
			border-width: 3px;
		}
	}
}
.pagination{
	display: flex;
	justify-content: center;
}
</style>
